/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { LoadingButton } from '@mui/lab';
import type { ReactNode } from 'react';

type SpinnerButtonProps = {
	isLoading: boolean;
	onClick: () => void;
	iconSrc: string;
	text: string;
};

export function SpinnerButton( { isLoading, onClick, text, iconSrc }: SpinnerButtonProps ): ReactNode {
	return (
		<LoadingButton
			loading={ isLoading }
			variant={ 'outlined' }
			loadingPosition={ 'start' }
			startIcon={ <img src={ iconSrc } /> }
			onClick={ onClick }
			sx={ { alignSelf: 'center' } }
		>
			<span>{ text }</span>
		</LoadingButton>
	);
}
